function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTilesMany = function SvgTilesMany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38 15.031H7.154c-1.137 0-2.056.818-2.056 1.824v7.29c0 1.005.92 1.822 2.056 1.822h8.224c1.137 0 2.056-.817 2.056-1.822v-7.29c0-1.006-.921-1.824-2.056-1.824zm0 8.202c0 .503-.461.912-1.029.912h-6.17c-.567 0-1.028-.409-1.028-.912v-5.467c0-.503.46-.911 1.028-.911h6.168c.568 0 1.029.408 1.029.911v5.467zm16.448-8.202h-8.225c-1.136 0-2.056.818-2.056 1.824v7.29c0 1.005.92 1.822 2.056 1.822h8.225c1.135 0 2.056-.817 2.056-1.822v-7.29c0-1.006-.921-1.824-2.056-1.824zm0 8.202c0 .503-.46.912-1.028.912h-6.168c-.568 0-1.029-.409-1.029-.912v-5.467c0-.503.461-.911 1.029-.911H30.8c.567 0 1.028.408 1.028.911zM15.379.452H7.155c-1.137 0-2.056.815-2.056 1.822v7.29c0 1.007.92 1.822 2.056 1.822h8.224c1.137 0 2.056-.815 2.056-1.822v-7.29c0-1.007-.921-1.822-2.056-1.822zm0 8.2c0 .504-.46.912-1.028.912h-6.17c-.567 0-1.028-.407-1.028-.911V3.185c0-.503.46-.91 1.028-.91h6.168c.568 0 1.029.406 1.029.91v5.468Zm16.449-8.2h-8.225c-1.136 0-2.056.815-2.056 1.822v7.29c0 1.007.92 1.822 2.056 1.822h8.225c1.135 0 2.056-.815 2.056-1.822v-7.29c0-1.007-.921-1.822-2.056-1.822zm0 8.2c0 .504-.46.912-1.028.912h-6.168c-.568 0-1.029-.407-1.029-.911V3.185c0-.503.461-.91 1.029-.91H30.8c.567 0 1.028.406 1.028.91z",
    style: {
      strokeWidth: 1.47992
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 4.903,
    y: 39.679
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.903,
    y: 39.679,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "VIEW")));
};
export default SvgTilesMany;